const translateIDForDocsMap: { [key: string]: string } = {
  'assert-view-sf': 'assert-view',
  'convert-type-rs': 'convert-type',
  'create-external-table-sf': 'create-external-table',
  'data-transfer-object': 'data-transfer',
  'extract-nested-data-sf': 'extract-nested-data',
  'microsoft-sql-server-output': 'sql-server-output',
  'query-to-grid': 'query-result-to-grid',
  'query-to-scalar': 'query-result-to-scalar',
  'rewrite-table-rs': 'rewrite-table',
  's3-unload-rs': 's3-unload'
}

export const translateIDForDocs = (componentSummaryId: string) => {
  // Translations weren't used here because the componentSummaryId is used in the URL for the component docs, we would need to check with the docs team if they are planning on internationizing slugs for the docs
  return translateIDForDocsMap[componentSummaryId] || componentSummaryId
}
